import firedux from '../firedux'

import {
  PRESENCE,
  PRESENCE_ENDPOINT
} from '../../config/constants'

export default (uid) => {
  const ENDPOINT = `${PRESENCE_ENDPOINT}/${uid}`

  firedux.ref.child(ENDPOINT).onDisconnect().set(PRESENCE.OFFLINE)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/set_user_offline_on_disconnect.js
 **/